import React from 'react';
import withStyles from "@material-ui/core/styles/withStyles";
import Button from "@material-ui/core/Button";
import { generate, distinctValues } from "../network/Reports";
import { get } from "../network/Resources";
import { getAnalytics } from "../network/Authwalls";
import { routePermissions } from '../../auth/network/Login'
import { withCookies } from "react-cookie";
import { format, subDays, subMonths, subYears } from 'date-fns'
import { CsvBuilder } from 'filefy';
import { Rule, Card, Message, Input, Form, Select, Grid, DatePicker } from 'shineout'

const service = 'reports';
const path = '';
const today = new Date()
const formatStart = 'yyyy-MM-dd 00:00:00'
const formatEnd = 'yyyy-MM-dd 23:59:59'
const rules = Rule();

// Fixed set of columns the CSV export always contains, regardless of which
// fields were used to filter the report.
const EXPORT_COLUMNS = [
    { title: 'EMAC', field: 'emac' },
    { title: 'Model', field: 'model' },
    { title: 'Brand', field: 'brand' },
    { title: 'MBoard', field: 'mboard' },
    { title: 'Panel', field: 'panel' },
    { title: 'L-Version', field: 'lversion' },
    { title: 'Serial No', field: 'serialno' },
    { title: 'COTA', field: 'cotaversion' },
    { title: 'FOTA', field: 'fotaversion' },
    { title: 'Features', field: 'features' },
    { title: 'Description', field: 'description' },
    { title: 'State', field: 'state' },
    { title: 'Date', field: 'createdAt' },
];
const styles = theme => ({
    theme: theme,
    root: {
        display: 'wrap',
    },
    container: {
        display: 'block',
        flexWrap: 'wrap',
    },
    fab: {
        margin: theme.spacing(1),
    },
    box: {
        component: 'div',
        display: 'inline',
        flexWrap: 'wrap',
    },
    card: {
        padding: theme.spacing(1),
        margin: theme.spacing(2),
    },
    textField: {
        margin: 8,
        padding: theme.spacing(1),
        width: 200,
    },
    media: {
        paddingTop: '56.25%',
    }
});

class Reports extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            column_templates: {
                emac: { title: 'EMAC', field: 'emac' },
                brand: { title: 'Brand', field: 'brand' },
                mboard: {
                    title: 'MBoard', field: 'mboard', cellStyle: {
                        overflow: 'hidden',
                        'text-overflow': 'ellipsis',
                    }
                },
                lversion: {
                    title: 'L-Version', field: 'lversion', cellStyle: {
                        overflow: 'hidden',
                        'text-overflow': 'ellipsis',
                    }
                },
                fotaversion: { title: 'FOTA', field: 'fotaversion' },
                features: {
                    title: 'Features', field: 'features', cellStyle: {
                        maxWidth: 250,
                        overflow: 'hidden',
                        'text-overflow': 'ellipsis',
                        'white-space': 'nowrap',
                    },
                    render: rowData => Array.isArray(rowData.features) ? rowData.features.join(', ') : rowData.features,
                },
                vendor: { title: 'Vendor', field: 'vendor' },
                factory: { title: 'Factory', field: 'factory' },
            },
            data: [],
            policies: JSON.parse(this.props.cookies.cookies.policy),
            fields: [],
            POST_DATA: [],
            rule_views: [],
            field: [],
            field_options: {},
            rule_data: {},
            filter_data: [],
            date_range: [],
            isLoading: false
        };
    }

    componentWillMount() {
        console.log({ service: service, path: path })
        routePermissions(this.props, { service: service, path: path }, result => {
            if (result === null) {
                this.setState({ isError: true })
            } else {
                result.map(method => {
                    this.setState({ [method.name]: true })
                    this.setState({ [method.name + '_DATA']: method.resources })
                })
                if (this.state.POST) {
                    var filter_fields = this.state.POST_DATA.find(e => e.key === 'filter_fields');
                    console.log(filter_fields)
                    if (!filter_fields) {
                        this.setState({ fields: null });
                    } else {
                        var field_list = [];
                        if (filter_fields.value.indexOf('*') > -1) {
                            field_list = Object.keys(this.state.column_templates);
                        } else {
                            field_list = filter_fields.value;
                        }
                        var rule_data = {};
                        field_list.map(field => {
                            rule_data[field] = {
                                field: field,
                                operator: '',
                                values: []
                            }
                        });
                        this.setState({ fields: field_list });
                        this.setState({ rule_data: rule_data })
                        prefetchFieldOptions(this, field_list);
                    }
                } else {
                    this.setState({ fields: null });
                }
            }
        })
    }

    downloadCsv = () => {
        const { data, report_name, date_range, filter_data } = this.state;
        if (!data || data.length === 0) {
            Message.error('No data to download. Run a search first.', 3, { position: 'bottom-right' });
            return;
        }

        const rows = data.map(row => EXPORT_COLUMNS.map(col => {
            var value = row[col.field];
            if (col.field === 'createdAt' && value) value = format(new Date(value), 'yyyy-MM-dd HH:mm:ss');
            if (Array.isArray(value)) value = value.join(', ');
            return value === undefined || value === null ? '' : value;
        }));

        rows.push([]);
        rows.push(['Date Range', date_range ? date_range.join(' to ') : 'All']);
        rows.push(['FILTERS']);
        (filter_data || []).map(filter => {
            rows.push(['', filter.field.toUpperCase(), filter.operator === 'IN' ? 'INCLUDING' : 'EXCLUDING', filter.values.join(', ')]);
        });
        rows.push(['TOTAL: ' + data.length]);

        new CsvBuilder((report_name || 'report') + '.csv')
            .setDelimeter(',')
            .setColumns(EXPORT_COLUMNS.map(col => col.title))
            .addRows(rows)
            .exportFile();
    }

    render() {
        return (
            <React.Fragment>
                <Card fullWidth>
                    <Card.Body>
                        <h2>Report Generation</h2>
                        <Form
                            onSubmit={value => {
                                console.log(value)
                                var data = [];
                                value.field.map(field => data.push(this.state.rule_data[field]))
                                console.log(data)
                                var invalidField = data.find(filter => !filter.operator || !filter.values || filter.values.length === 0);
                                if (invalidField) {
                                    Message.error('Select an operator and at least one value for "' + invalidField.field + '"', 3, { position: 'bottom-right' });
                                    return;
                                }
                                this.setState({ filter_data: data })
                                var date_range = value.date_range ? value.date_range : ["", ""];
                                if (date_range[0] === '' || date_range[1] === '') {
                                    date_range = undefined;
                                }
                                this.setState({ date_range: date_range })
                                this.setState({ isLoading: true, data: [] })
                                generate({ filters: data, date_range: date_range }, (result, errorMessage) => {
                                    console.log(result)
                                    this.setState({ isLoading: false })
                                    if (result == null) {
                                        this.setState({ data: [] })
                                        Message.error(errorMessage || 'No Data Available', 5, { position: 'bottom-right' });
                                    } else {
                                        this.setState({ data: result })
                                        Message.success('Data Found', 3, { position: 'bottom-right' });
                                    }
                                })
                            }}
                        >
                            <Grid gutter={2}>
                                <Grid width={0.3}>
                                    <Form.Item required label="Report Name">
                                        <Input
                                            name="report_name"
                                            fullWidth
                                            onChange={value => this.setState({ report_name: value })}
                                            value={this.state.report_name}
                                            rules={[rules.required, rules.isExist]}
                                        />
                                    </Form.Item>
                                </Grid>
                                <Grid width={0.3}>
                                    <Form.Item required label="Fields">
                                        <Select
                                            name="field"
                                            fullWidth
                                            absolute
                                            style={{ marginRight: 8 }}

                                            onChange={value => {
                                                this.setState({ field: value });
                                                getRuleView(this, value, views => {
                                                    this.setState({ rule_views: views })
                                                })
                                            }}
                                            data={this.state.fields}
                                            clearable
                                            keygen
                                            onFilter={text => d => d.toLowerCase().indexOf(text.toLowerCase()) >= 0}
                                            rules={[rules.required, rules.isExist]}
                                            multiple />
                                    </Form.Item>
                                </Grid>
                            </Grid>
                            <Form.Item label="Date between">
                                <DatePicker
                                    name="date_range"
                                    range
                                    onChange={d => console.log(d)}
                                    type="datetime"
                                    inputable
                                    quickSelect={[
                                        {
                                            name: 'Day',
                                            value: [format(today, formatStart), format(today, formatEnd)],
                                        },
                                        {
                                            name: 'Week',
                                            value: [format(subDays(today, 7), formatStart), format(today, formatEnd)],
                                        },
                                        {
                                            name: 'Month',
                                            value: [format(subMonths(today, 1), formatStart), format(today, formatEnd)],
                                        },
                                        {
                                            name: 'Half Year',
                                            value: [format(subMonths(today, 6), formatStart), format(today, formatEnd)],
                                        },
                                        {
                                            name: 'Annual',
                                            value: [format(subYears(today, 1), formatStart), format(today, formatEnd)],
                                        },
                                    ]}
                                    style={{ marginTop: '12px' }}
                                />
                            </Form.Item>
                            {this.state.rule_views}
                        </Form>

                        <Card.Submit
                            style={{
                                marginTop: 20,
                                marginBottom: 20,
                                width: 'auto',
                                minWidth: 120,
                            }}
                        >{this.state.isLoading ? 'Searching...' : 'Search'}</Card.Submit>

                        {this.state.data && this.state.data.length > 0 ? (
                            <div style={{ marginTop: 20 }}>
                                <p>{this.state.data.length} record(s) found.</p>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    onClick={this.downloadCsv}
                                >Download CSV</Button>
                            </div>
                        ) : null}
                    </Card.Body>
                </Card>
            </React.Fragment >
        );
    }
}

// Fields with a master list we can fetch from /resources when the policy allows all values ('*').
// Maps the report field name to the /resources `type` query param.
// 'features' is deliberately excluded here — the /resources 'feature' catalog only has a handful of
// curated entries, while devices in the field carry hundreds more distinct feature strings. It's
// sourced from the authwalls analytics rollup instead (see extractFeatureNames below).
const MASTER_LIST_FIELDS = {
    brand: 'brand',
    mboard: 'mboard',
    vendor: 'vendor',
    factory: 'factory',
};

// Fields with no /resources master list — sourced from distinct values across actual devices instead.
const DISTINCT_VALUE_FIELDS = ['lversion', 'fotaversion'];

// Flattens the brand -> boards -> features nesting returned by /lm/v1/authwalls/analytics
// into a deduplicated, sorted list of feature names actually present on devices.
function extractFeatureNames(analyticsData) {
    var features = new Set();
    (Array.isArray(analyticsData) ? analyticsData : []).forEach(brand => {
        (Array.isArray(brand.boards) ? brand.boards : []).forEach(board => {
            (Array.isArray(board.features) ? board.features : []).forEach(feature => {
                if (feature) features.add(feature);
            });
        });
    });
    return Array.from(features).sort();
}

// Resolves a field's fixed policy value list, if any, without triggering a fetch.
function getFixedPolicyValues(ref, field) {
    if (field === 'emac') return null;
    var policyResource = ref.state.POST_DATA.find(e => e.key === field);
    return policyResource && Array.isArray(policyResource.value) && policyResource.value.indexOf('*') === -1
        ? policyResource.value
        : null;
}

// Kicks off background fetches (once) for every field whose dropdown needs data from the server —
// brand/mboard/vendor/factory/features when the policy allows all values, and lversion/fotaversion
// always (they have no policy resource at all). Populates ref.state.field_options as results land,
// and re-renders the currently selected fields so their dropdowns appear once data arrives.
function prefetchFieldOptions(ref, fields) {
    fields.forEach(field => {
        if (getFixedPolicyValues(ref, field) !== null) return;
        if (ref.state.field_options[field] !== undefined) return;

        var policyResource = field === 'emac' ? null : ref.state.POST_DATA.find(e => e.key === field);
        // Treat "no policy resource defined for this field" the same as unrestricted ('*') —
        // most fields (vendor, factory, features, lversion, fotaversion) simply have no entry
        // in the reports policy at all, since the backend only ever validates brand/mboard.
        var isUnrestricted = !policyResource || (Array.isArray(policyResource.value) && policyResource.value.indexOf('*') > -1);

        var fetcher = null;
        if (field === 'features' && isUnrestricted) {
            fetcher = cb => getAnalytics(data => cb(extractFeatureNames(data)));
        } else if (isUnrestricted && MASTER_LIST_FIELDS[field]) {
            fetcher = cb => get({ type: MASTER_LIST_FIELDS[field] }, options => {
                cb(Array.isArray(options) ? options.map(o => o.name).filter(Boolean) : []);
            });
        } else if (DISTINCT_VALUE_FIELDS.indexOf(field) > -1) {
            fetcher = cb => distinctValues(field, values => cb(Array.isArray(values) ? values : []));
        }

        if (!fetcher) return;

        ref.setState(oldState => ({ field_options: Object.assign({}, oldState.field_options, { [field]: [] }) }), () => {
            fetcher(values => {
                ref.setState(oldState => ({ field_options: Object.assign({}, oldState.field_options, { [field]: values }) }), () => {
                    if (ref.state.field.indexOf(field) > -1) {
                        getRuleView(ref, ref.state.field, views => ref.setState({ rule_views: views }));
                    }
                });
            });
        });
    });
}

function getRuleView(ref, data, callback) {
    console.log(data)
    const rule_views = data.map(field => {
        var fixedValues = getFixedPolicyValues(ref, field);
        var fetchedValues = ref.state.field_options[field];
        var allowedValues = fixedValues || (Array.isArray(fetchedValues) && fetchedValues.length ? fetchedValues : null);

        return (
            <Card key={field}>
                <Card.Body>
                    <Form
                        value={ref.state.rule_data[field]}
                        onChange={value => console.log(value)}
                    >
                        <h3>{field}</h3>
                        <Grid gutter={1}
                            style={{
                                display: "flex",
                                alignItems: "center",
                                marginBottom: 12
                            }}>
                            <Grid width={0.5}>
                                <Form.Item required label="Operator">
                                    <Select
                                        name="operator"
                                        fullWidth
                                        style={{ marginRight: 8 }}
                                        data={["IN", "NIN"]}
                                        onChange={value => {
                                            ref.setState(oldState => {
                                                console.log(field)
                                                console.log(oldState.rule_data)
                                                oldState.rule_data[field].operator = value
                                                return { rule_data: oldState.rule_data }
                                            })
                                        }}
                                        clearable
                                        keygen
                                        single
                                        rules={[rules.required, rules.isExist]}
                                    />
                                </Form.Item>
                            </Grid>
                            <Grid width={0.5}>
                                <Form.Item required label={allowedValues ? 'Values' : 'Values (comma separated)'}>
                                    {allowedValues ? (
                                        <Select
                                            name="values"
                                            fullWidth
                                            absolute
                                            style={{ marginRight: 8 }}
                                            data={allowedValues}
                                            clearable
                                            keygen
                                            multiple
                                            onFilter={text => d => String(d).toLowerCase().indexOf(text.toLowerCase()) >= 0}
                                            onChange={value => {
                                                ref.setState(oldState => {
                                                    oldState.rule_data[field].values = value || []
                                                    return { rule_data: oldState.rule_data }
                                                })
                                            }}
                                            rules={[rules.required, rules.isExist]}
                                        />
                                    ) : (
                                        <Input
                                            name="values"
                                            fullWidth
                                            style={{ marginRight: 8 }}
                                            placeholder="e.g. value1, value2, value3"
                                            onChange={value => {
                                                ref.setState(oldState => {
                                                    oldState.rule_data[field].values = (value || '')
                                                        .split(',')
                                                        .map(v => v.trim())
                                                        .filter(v => v.length > 0)
                                                    return { rule_data: oldState.rule_data }
                                                })
                                            }}
                                            rules={[rules.required, rules.isExist]}
                                        />
                                    )}
                                </Form.Item>
                            </Grid>
                        </Grid>

                    </Form>
                </Card.Body>
            </Card>
        );
    });
    callback(rule_views)
}

export default withStyles(styles)(withCookies(Reports));
